import { useUser } from '@paintscout/ui-business'
import { useEffect } from 'react'
import type { RouteComponentProps } from 'react-router-dom'

export default function HubSpotFormProxy({ match }: RouteComponentProps<{ formId: string }>) {
  const { user } = useUser()
  const { formId } = match.params
  useEffect(() => {
    if (user?.email && formId) {
      const url = `https://5nj1jy.share-na3.hsforms.com/${encodeURIComponent(formId)}?email=${encodeURIComponent(user.email)}`
      // eslint-disable-next-line xss/no-location-href-assign
      window.location.href = url
    }
  }, [user?.email, formId])

  return null
}
